import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setSelectVehicleModelsModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { VehicleModelListContent } from 'bff/models/product';
import Modal from 'components/Modal';

const SelectVehicleModelsModal: React.FC<IProps> = (props) => {
  const [activeName, setActiveName] = React.useState<string>();
  const [query, setQuery] = React.useState<string>();

  const filteredList = React.useMemo(() => {
    const lowerQuery = query?.toLowerCase();

    if (!lowerQuery) return props.vehicleModels;
    if (lowerQuery) return props.vehicleModels.filter(item => item.NAME.toLowerCase().includes(lowerQuery));
  }, [query, props.vehicleModels]);

  /**
   * @description 設置已選取的車型選項 index (已選取選項顯示打勾icon)
   */
  React.useEffect(() => {
    const model = props.vehicleModels.filter((model: VehicleModelListContent) => model.TYPE_CODE.join(',') === props.activeVehicleModel);
    if (model[0]) setActiveName(model[0].NAME);
  }, [props.activeVehicleModel, props.vehicleModels]);

  /**
   * @description 車型選項選取後執行的事件
   */
  const handleSelected = (activeIndex: number) => {
    const selectedVehicleModel = props.vehicleModels[activeIndex];
    // 設置已選取的車型選項 index (已選取選項顯示打勾icon)
    setActiveName(selectedVehicleModel.NAME);

    // 設置 Field Value
    props.formikSetFieldValue(props.formikFieldNameVehicleModel, selectedVehicleModel.TYPE_CODE.join(','));
    props.formikSetFieldTouched(props.formikFieldNameVehicleModel, false);

    props.formikSetFieldValue(props.formikFieldNameVehicleModelName, selectedVehicleModel.NAME);
    props.formikSetFieldTouched(props.formikFieldNameVehicleModelName, false);

    // 執行「設置重置價格」
    props.onSetVehicleInfo(selectedVehicleModel, props.formikSetFieldValue);
    // 執行「設定乘載人數」
    props.onFetchLIMIT(selectedVehicleModel.TYPE_CODE.join(','), props.formikSetFieldValue);
    // 執行「選擇車型切換排氣量或馬力 Radio Button 值」
    props.handleVehiclePowerOptionToggle(selectedVehicleModel.TYPE_CODE[selectedVehicleModel.TYPE_CODE.length - 1], props.formikSetFieldValue);
    // 關閉 Modal
    handleClose();
  };

  /**
   * @description 關閉 Modal
   */
  const handleClose = () => {
    props.setSelectVehicleModelsModalVisible(false);
  };

  return (
    <div className="select-vehicle-models-modal">
      <Modal
        visible={props.modal.selectVehicleModelsModalState.visible}
        title="選擇車型"
        confirmButton={false}
        onCancel={handleClose}
      >
        <div className="select-vehicle-models-modal__search">
          <input
            type="text"
            className="select-vehicle-models-modal__search-input"
            placeholder="搜尋..."
            onChange={e => setQuery(e.target.value)}
          />
        </div>
        {filteredList && filteredList.length > 0 && (
          <div className="select-vehicle-models-modal__models-list">
            <div className="select-vehicle-models-modal__models-list-header">
              <div className="select-vehicle-models-modal__model-item-col">車型</div>
              <div className="select-vehicle-models-modal__model-item-col">排氣量或馬力</div>
              <div className="select-vehicle-models-modal__model-item-col">重置價格</div>
            </div>
            <div className="select-vehicle-models-modal__models-list-content">
              {filteredList.map((model: VehicleModelListContent, index: number) => (
                <div className={'select-vehicle-models-modal__model-item' + (model.NAME === activeName ? ' select-vehicle-models-modal__model-item--active' : '')} key={index} onClick={() => handleSelected(index)}>
                  <div className="select-vehicle-models-modal__model-item-col">{model.NAME}</div>
                  <div className="select-vehicle-models-modal__model-item-col">{model.DISPLACEMENT} {props.prowerUnit}</div>
                  <div className="select-vehicle-models-modal__model-item-col">{model.REPLACEMENT_PRICE}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectVehicleModelsModalVisible: (visible: boolean) => dispatch(setSelectVehicleModelsModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectVehicleModelsModal);
